import { render, staticRenderFns } from "./Paw.vue?vue&type=template&id=6511c88e&scoped=true"
import script from "./Paw.vue?vue&type=script&lang=js"
export * from "./Paw.vue?vue&type=script&lang=js"
import style0 from "./Paw.vue?vue&type=style&index=0&id=6511c88e&prod&scoped=true&lang=css"
import style1 from "./Paw.vue?vue&type=style&index=1&id=6511c88e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6511c88e",
  null
  
)

export default component.exports